import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { OnboardingImportLauncherProps } from '../src/components/OnboardingImportLauncherProps.ts';

export type {
	OnboardingImportLauncherProps,
	OnboardingImportLauncherRenderProps,
} from '../src/components/OnboardingImportLauncherProps.ts';

export const OnboardingImportLauncher: LoadableType<OnboardingImportLauncherProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-componentsOnboardingImportLauncher" */ '../src/components/OnboardingImportLauncher.tsx'
				)
			).OnboardingImportLauncher,
	});
